/**
 * Cookie package - Comprehensive cookie and consent management utilities
 *
 * This package provides:
 * - Basic cookie operations (get, set, delete, parse)
 * - OneTrust consent management
 * - TypeScript types and enums
 */

// Export basic cookie utilities
export {
  applyRawCookieString,
  cookieAsObject,
  deleteCookie,
  getAllCookieValues,
  getCookie,
  setCookie,
} from './cookie-utils'

// Export OneTrust consent management
export {
  getOneTrustConsent,
  getOneTrustConsentPreferences,
  isConsentCategoryEnabled,
  OneTrustCategories,
  OPTANON_COOKIE_NAME,
  OPTANON_DEFAULT_CONSENT,
  setAssumedConsent,
  transformOneTrustConsent,
} from './consent'

// Export types
export type {
  CookieOptions,
  DeleteCookieOptions,
  OneTrustConsentPreferences,
} from './types'

// Legacy exports for backward compatibility
import { OneTrustCategories } from './types'
export { OneTrustCategories as ConsentCategories }
